import { render, staticRenderFns } from "./VTYHV1Component.vue?vue&type=template&id=408a28b2&scoped=true&"
import script from "./VTYHV1Component.vue?vue&type=script&lang=js&"
export * from "./VTYHV1Component.vue?vue&type=script&lang=js&"
import style0 from "./VTYHV1Component.vue?vue&type=style&index=0&id=408a28b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a28b2",
  null
  
)

export default component.exports